import React from 'react';
import { Switch, Route as Router } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import PropTypes from 'prop-types';

import AddDepartments from '../pages/Departments/Add';
import AddUsers from '../pages/Users/Add';
import AddPABXs from '../pages/PABXs/Add';
import AddNetworkGroup from '../pages/NetworksGroup/Add';
import AddDevices from '../pages/Devices/Add';
import AddStatus from '../pages/Status/Add';
import AddExpedients from '../pages/Expedients/Add';
import AddIVRs from '../pages/IVRs/Add';
import AddManufacturers from '../pages/Manufacturers/Add';
import AddCategories from '../pages/Categories/Add';
import AddProducts from '../pages/Products/Add';
import AddServices from '../pages/Services/Add';
import AddClients from '../pages/Clients/Add';
import AddSpecies from '../pages/Species/Add';
import AddBreeds from '../pages/Breeds/Add';
import AddPets from '../pages/Pets/Add';
import AddTypeOccurrences from '../pages/TypeOccurrences/Add';
import AddOccurrences from '../pages/Occurrences/Add';
import AddTypeSchedules from '../pages/TypeSchedules/Add';
import AddSchedules from '../pages/Schedules/Add';
import AddVeterinarians from '../pages/Veterinarians/Add';
import AddCompanies from '../pages/Companies/Add';
import AddPermissionsGroup from '../pages/PermissionsGroup/Add';
import AddCodesNCM from '../pages/CodesNCM/Add';
import AddSuppliers from '../pages/Suppliers/Add';

import ListDepartments from '../pages/Departments/List';
import ListUsers from '../pages/Users/List';
import ListPABXs from '../pages/PABXs/List';
import ListNetworkGroup from '../pages/NetworksGroup/List';
import ListDevices from '../pages/Devices/List';
import ListStatus from '../pages/Status/List';
import ListExpedients from '../pages/Expedients/List';
import ListIVRs from '../pages/IVRs/List';
import ListManufacturers from '../pages/Manufacturers/List';
import ListCategories from '../pages/Categories/List';
import ListProducts from '../pages/Products/List';
import ListServices from '../pages/Services/List';
import ListClients from '../pages/Clients/List';
import ListSpecies from '../pages/Species/List';
import ListBreeds from '../pages/Breeds/List';
import ListPets from '../pages/Pets/List';
import ListTypeOccurrences from '../pages/TypeOccurrences/List';
import ListOccurrences from '../pages/Occurrences/List';
import ListTypeSchedules from '../pages/TypeSchedules/List';
import ListSchedules from '../pages/Schedules/List';
import ListVeterinarians from '../pages/Veterinarians/List';
import ListCompanies from '../pages/Companies/List';
import ListPermissionsGroup from '../pages/PermissionsGroup/List';
import ListCodesNCM from '../pages/CodesNCM/List';
import ListSuppliers from '../pages/Suppliers/List';

import EditDepartments from '../pages/Departments/Edit';
import EditUsers from '../pages/Users/Edit';
import EditPABXs from '../pages/PABXs/Edit';
import EditNetworkGroup from '../pages/NetworksGroup/Edit';
import EditDevices from '../pages/Devices/Edit';
import EditStatus from '../pages/Status/Edit';
import EditExpedients from '../pages/Expedients/Edit';
import EditIVRs from '../pages/IVRs/Edit';
import EditManufacturers from '../pages/Manufacturers/Edit';
import EditCategories from '../pages/Categories/Edit';
import EditProducts from '../pages/Products/Edit';
import EditServices from '../pages/Services/Edit';
import EditClients from '../pages/Clients/Edit';
import EditSpecies from '../pages/Species/Edit';
import EditBreeds from '../pages/Breeds/Edit';
import EditPets from '../pages/Pets/Edit';
import EditTypeOccurrences from '../pages/TypeOccurrences/Edit';
import EditOccurrences from '../pages/Occurrences/Edit';
import EditTypeSchedules from '../pages/TypeSchedules/Edit';
import EditSchedules from '../pages/Schedules/Edit';
import EditVeterinarians from '../pages/Veterinarians/Edit';
import EditCompanies from '../pages/Companies/Edit';
import EditPermissionsGroup from '../pages/PermissionsGroup/Edit';
import EditCodesNCM from '../pages/CodesNCM/Edit';
import EditSuppliers from '../pages/Suppliers/Edit';

import Wrapper from '../components/Wrapper';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashbord';
import GroupsConfig from '../pages/GroupsConfig';
import NotFound from '../pages/NotFound';
import IP from '../pages/Recorder/IP';
import Analogic from '../pages/Recorder/Analogic';
import Recordings from '../pages/Recorder/Recordings';
import ReportsGroups from '../pages/Reports/Groups';
import ReportsUsers from '../pages/Reports/Users';
import ReportsEvents from '../pages/Reports/Events';
import IVRConfig from '../pages/IVRs/Config';
import IVROptions from '../pages/IVRs/Options';

const Routes = props => {
  const { history } = props;

  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Router exact path="/" component={Login} />
        {/* Criar */}
        <Router
          exact
          path="/departments/add"
          render={props => <Wrapper {...props} component={AddDepartments} />}
        />
        <Router
          exact
          path="/users/add"
          render={props => <Wrapper {...props} component={AddUsers} />}
        />
        <Router
          exact
          path="/pabxs/add"
          render={props => <Wrapper {...props} component={AddPABXs} />}
        />
        <Router
          exact
          path="/networks_group/add"
          render={props => <Wrapper {...props} component={AddNetworkGroup} />}
        />
        <Router
          exact
          path="/devices/add"
          render={props => <Wrapper {...props} component={AddDevices} />}
        />
        <Router
          exact
          path="/status/add"
          render={props => <Wrapper {...props} component={AddStatus} />}
        />
        <Router
          exact
          path="/expedients/add"
          render={props => <Wrapper {...props} component={AddExpedients} />}
        />
        <Router
          exact
          path="/ivrs/add"
          render={props => <Wrapper {...props} component={AddIVRs} />}
        />
        <Router
          exact
          path="/manufacturers/add"
          render={props => <Wrapper {...props} component={AddManufacturers} />}
        />
        <Router
          exact
          path="/categories/add"
          render={props => <Wrapper {...props} component={AddCategories} />}
        />
        <Router
          exact
          path="/products/add"
          render={props => <Wrapper {...props} component={AddProducts} />}
        />
        <Router
          exact
          path="/services/add"
          render={props => <Wrapper {...props} component={AddServices} />}
        />
        <Router
          exact
          path="/clients/add"
          render={props => <Wrapper {...props} component={AddClients} />}
        />
        <Router
          exact
          path="/species/add"
          render={props => <Wrapper {...props} component={AddSpecies} />}
        />
        <Router
          exact
          path="/breeds/add"
          render={props => <Wrapper {...props} component={AddBreeds} />}
        />
        <Router
          exact
          path="/pets/add"
          render={props => <Wrapper {...props} component={AddPets} />}
        />
        <Router
          exact
          path="/type_occurrences/add"
          render={props => (
            <Wrapper {...props} component={AddTypeOccurrences} />
          )}
        />
        <Router
          exact
          path="/occurrences/add"
          render={props => <Wrapper {...props} component={AddOccurrences} />}
        />
        <Router
          exact
          path="/type_schedules/add"
          render={props => <Wrapper {...props} component={AddTypeSchedules} />}
        />
        <Router
          exact
          path="/schedules/add"
          render={props => <Wrapper {...props} component={AddSchedules} />}
        />
        <Router
          exact
          path="/veterinarians/add"
          render={props => <Wrapper {...props} component={AddVeterinarians} />}
        />
        <Router
          exact
          path="/companies/add"
          render={props => <Wrapper {...props} component={AddCompanies} />}
        />
        <Router
          exact
          path="/permissions_group/add"
          render={props => (
            <Wrapper {...props} component={AddPermissionsGroup} />
          )}
        />
        <Router
          exact
          path="/codes_ncm/add"
          render={props => <Wrapper {...props} component={AddCodesNCM} />}
        />
        <Router
          exact
          path="/suppliers/add"
          render={props => <Wrapper {...props} component={AddSuppliers} />}
        />
        {/* Listar */}
        <Router
          exact
          path="/departments"
          render={props => <Wrapper {...props} component={ListDepartments} />}
        />
        <Router
          exact
          path="/users"
          render={props => <Wrapper {...props} component={ListUsers} />}
        />
        <Router
          exact
          path="/pabxs"
          render={props => <Wrapper {...props} component={ListPABXs} />}
        />
        <Router
          exact
          path="/networks_group"
          render={props => <Wrapper {...props} component={ListNetworkGroup} />}
        />
        <Router
          exact
          path="/devices"
          render={props => <Wrapper {...props} component={ListDevices} />}
        />
        <Router
          exact
          path="/status"
          render={props => <Wrapper {...props} component={ListStatus} />}
        />
        <Router
          exact
          path="/expedients"
          render={props => <Wrapper {...props} component={ListExpedients} />}
        />
        <Router
          exact
          path="/ivrs"
          render={props => <Wrapper {...props} component={ListIVRs} />}
        />
        <Router
          exact
          path="/manufacturers"
          render={props => <Wrapper {...props} component={ListManufacturers} />}
        />
        <Router
          exact
          path="/categories"
          render={props => <Wrapper {...props} component={ListCategories} />}
        />
        <Router
          exact
          path="/products"
          render={props => <Wrapper {...props} component={ListProducts} />}
        />
        <Router
          exact
          path="/services"
          render={props => <Wrapper {...props} component={ListServices} />}
        />
        <Router
          exact
          path="/clients"
          render={props => <Wrapper {...props} component={ListClients} />}
        />
        <Router
          exact
          path="/species"
          render={props => <Wrapper {...props} component={ListSpecies} />}
        />
        <Router
          exact
          path="/breeds"
          render={props => <Wrapper {...props} component={ListBreeds} />}
        />
        <Router
          exact
          path="/pets"
          render={props => <Wrapper {...props} component={ListPets} />}
        />
        <Router
          exact
          path="/type_occurrences"
          render={props => (
            <Wrapper {...props} component={ListTypeOccurrences} />
          )}
        />
        <Router
          exact
          path="/occurrences"
          render={props => <Wrapper {...props} component={ListOccurrences} />}
        />
        <Router
          exact
          path="/type_schedules"
          render={props => <Wrapper {...props} component={ListTypeSchedules} />}
        />
        <Router
          exact
          path="/schedules"
          render={props => <Wrapper {...props} component={ListSchedules} />}
        />
        <Router
          exact
          path="/veterinarians"
          render={props => <Wrapper {...props} component={ListVeterinarians} />}
        />
        <Router
          exact
          path="/companies"
          render={props => <Wrapper {...props} component={ListCompanies} />}
        />
        <Router
          exact
          path="/permissions_group"
          render={props => (
            <Wrapper {...props} component={ListPermissionsGroup} />
          )}
        />
        <Router
          exact
          path="/codes_ncm"
          render={props => <Wrapper {...props} component={ListCodesNCM} />}
        />
        <Router
          exact
          path="/suppliers"
          render={props => <Wrapper {...props} component={ListSuppliers} />}
        />
        {/* Editar */}
        <Router
          exact
          path="/departments/edit/:id"
          render={props => <Wrapper {...props} component={EditDepartments} />}
        />
        <Router
          exact
          path="/users/edit/:id"
          render={props => <Wrapper {...props} component={EditUsers} />}
        />
        <Router
          exact
          path="/pabxs/edit/:id"
          render={props => <Wrapper {...props} component={EditPABXs} />}
        />
        <Router
          exact
          path="/networks_group/edit/:id"
          render={props => <Wrapper {...props} component={EditNetworkGroup} />}
        />
        <Router
          exact
          path="/devices/edit/:id"
          render={props => <Wrapper {...props} component={EditDevices} />}
        />
        <Router
          exact
          path="/status/edit/:id"
          render={props => <Wrapper {...props} component={EditStatus} />}
        />
        <Router
          exact
          path="/expedients/edit/:id"
          render={props => <Wrapper {...props} component={EditExpedients} />}
        />
        <Router
          exact
          path="/ivrs/edit/:id"
          render={props => <Wrapper {...props} component={EditIVRs} />}
        />
        <Router
          exact
          path="/manufacturers/edit/:id"
          render={props => <Wrapper {...props} component={EditManufacturers} />}
        />
        <Router
          exact
          path="/categories/edit/:id"
          render={props => <Wrapper {...props} component={EditCategories} />}
        />
        <Router
          exact
          path="/products/edit/:id"
          render={props => <Wrapper {...props} component={EditProducts} />}
        />
        <Router
          exact
          path="/services/edit/:id"
          render={props => <Wrapper {...props} component={EditServices} />}
        />
        <Router
          exact
          path="/clients/edit/:id"
          render={props => <Wrapper {...props} component={EditClients} />}
        />
        <Router
          exact
          path="/species/edit/:id"
          render={props => <Wrapper {...props} component={EditSpecies} />}
        />
        <Router
          exact
          path="/breeds/edit/:id"
          render={props => <Wrapper {...props} component={EditBreeds} />}
        />
        <Router
          exact
          path="/pets/edit/:id"
          render={props => <Wrapper {...props} component={EditPets} />}
        />
        <Router
          exact
          path="/type_occurrences/edit/:id"
          render={props => (
            <Wrapper {...props} component={EditTypeOccurrences} />
          )}
        />
        <Router
          exact
          path="/occurrences/edit/:id"
          render={props => <Wrapper {...props} component={EditOccurrences} />}
        />
        <Router
          exact
          path="/type_schedules/edit/:id"
          render={props => <Wrapper {...props} component={EditTypeSchedules} />}
        />
        <Router
          exact
          path="/schedules/edit/:id"
          render={props => <Wrapper {...props} component={EditSchedules} />}
        />
        <Router
          exact
          path="/veterinarians/edit/:id"
          render={props => <Wrapper {...props} component={EditVeterinarians} />}
        />
        <Router
          exact
          path="/companies/edit/:id"
          render={props => <Wrapper {...props} component={EditCompanies} />}
        />
        <Router
          exact
          path="/permissions_group/edit/:id"
          render={props => (
            <Wrapper {...props} component={EditPermissionsGroup} />
          )}
        />
        <Router
          exact
          path="/codes_ncm/edit/:id"
          render={props => <Wrapper {...props} component={EditCodesNCM} />}
        />
        <Router
          exact
          path="/suppliers/edit/:id"
          render={props => <Wrapper {...props} component={EditSuppliers} />}
        />
        {/* Outras Rotas */}
        <Router
          exact
          path="/groups_config"
          render={props => <Wrapper {...props} component={GroupsConfig} />}
        />
        <Router
          exact
          path="/dashboard"
          render={props => <Wrapper {...props} component={Dashboard} />}
        />
        <Router
          exact
          path="/recorder/ip"
          render={props => <Wrapper {...props} component={IP} />}
        />
        <Router
          exact
          path="/recorder/analogic"
          render={props => <Wrapper {...props} component={Analogic} />}
        />
        <Router
          exact
          path="/recorder/recordings"
          render={props => <Wrapper {...props} component={Recordings} />}
        />
        {/* Relatórios */}
        <Router
          exact
          path="/reports/users"
          render={props => <Wrapper {...props} component={ReportsUsers} />}
        />
        <Router
          exact
          path="/reports/events"
          render={props => <Wrapper {...props} component={ReportsEvents} />}
        />
        <Router
          exact
          path="/reports/groups"
          render={props => <Wrapper {...props} component={ReportsGroups} />}
        />
        <Router
          exact
          path="/ivrs/options/:id"
          render={props => <Wrapper {...props} component={IVROptions} />}
        />
        <Router
          exact
          path="/ivrs/config"
          render={props => <Wrapper {...props} component={IVRConfig} />}
        />
        <Router component={NotFound} />
      </Switch>
    </ConnectedRouter>
  );
};

Routes.propTypes = {
  history: PropTypes.object
};

export default Routes;
